import { render, staticRenderFns } from "./BlogDetailsDynamic.vue?vue&type=template&id=616229ac"
import script from "./BlogDetailsDynamic.vue?vue&type=script&lang=js"
export * from "./BlogDetailsDynamic.vue?vue&type=script&lang=js"
import style0 from "./BlogDetailsDynamic.vue?vue&type=style&index=0&id=616229ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports